import { jsx as r, jsxs as m } from "react/jsx-runtime";
import { createContext as N, forwardRef as l, useMemo as w, useContext as v } from "react";
import { faChevronUp as C, faChevronDown as d } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as c } from "@fortawesome/react-fontawesome";
import * as t from "@radix-ui/react-select";
import { twMerge as i } from "tailwind-merge";
const I = t.Group, B = t.ItemText, g = N({
  isError: !1
}), T = ({ error: e = !1, triggerRef: o, ...n }) => {
  const a = w(() => ({ isError: e, triggerRef: o }), [e, o]);
  return /* @__PURE__ */ r(g.Provider, { value: a, children: /* @__PURE__ */ r(t.Root, { ...n }) });
}, j = ({
  size: e = "md",
  className: o,
  children: n,
  ...a
}) => {
  const { isError: s, triggerRef: b } = v(g);
  return /* @__PURE__ */ m(
    t.Trigger,
    {
      ref: b,
      "data-givebutter-primitive": "single-select",
      className: i(
        // base
        "group/trigger relative flex h-full w-full min-w-0 flex-shrink-0 cursor-pointer appearance-none items-center justify-between gap-2 rounded-lg border-none bg-white px-4 py-2 text-base leading-4 text-gray-900 outline-none",
        // border
        "ring-1 ring-inset ring-gray-300",
        // focus
        "radix-state-open:ring-2 radix-state-open:ring-blue-500 focus:ring-2 focus:ring-blue-500",
        // disabled
        "radix-disabled:cursor-not-allowed radix-disabled:bg-gray-50 radix-disabled:text-gray-900",
        // error
        s && "ring-2 ring-red-500",
        // size
        e === "sm" && "h-8 text-sm",
        e === "md" && "h-10",
        e === "lg" && "h-12",
        //
        o
      ),
      ...a,
      children: [
        /* @__PURE__ */ r("div", { className: "truncate leading-6", children: n || /* @__PURE__ */ r(p, {}) }),
        /* @__PURE__ */ r(t.Icon, { asChild: !0, children: /* @__PURE__ */ r(
          c,
          {
            icon: d,
            className: "group-radix-state-open/trigger:rotate-180 text-xs"
          }
        ) })
      ]
    }
  );
}, p = l(
  ({ className: e, placeholder: o = "Select", ...n }, a) => /* @__PURE__ */ r(
    t.Value,
    {
      ref: a,
      className: e,
      placeholder: o,
      ...n
    }
  )
), u = l(
  ({ className: e, children: o, sideOffset: n = 4, ...a }, s) => /* @__PURE__ */ r(t.Portal, { children: /* @__PURE__ */ m(
    t.Content,
    {
      ref: s,
      position: "popper",
      sideOffset: n,
      className: i(
        "z-pentOutermost relative m-0 max-h-72 min-w-[--radix-select-trigger-width] overflow-hidden rounded-md border-none bg-white shadow-md ring-1 ring-gray-200",
        e
      ),
      ...a,
      children: [
        /* @__PURE__ */ r(f, {}),
        /* @__PURE__ */ r(t.Viewport, { className: "flex flex-col p-1", children: o }),
        /* @__PURE__ */ r(x, {})
      ]
    }
  ) })
);
u.displayName = t.Content.displayName;
const f = l(
  ({ className: e, ...o }, n) => /* @__PURE__ */ r(
    t.ScrollUpButton,
    {
      ref: n,
      className: i(
        "absolute left-0 right-0 top-0 z-10 flex cursor-default items-center justify-center bg-gradient-to-b from-white to-transparent py-1",
        e
      ),
      ...o,
      children: /* @__PURE__ */ r(c, { icon: C, className: "size-3" })
    }
  )
);
f.displayName = t.ScrollUpButton.displayName;
const x = l(
  ({ className: e, ...o }, n) => /* @__PURE__ */ r(
    t.ScrollDownButton,
    {
      ref: n,
      className: i(
        "absolute bottom-0 left-0 right-0 z-10 flex cursor-default items-center justify-center bg-gradient-to-t from-white to-transparent py-1",
        e
      ),
      ...o,
      children: /* @__PURE__ */ r(c, { icon: d, className: "size-3" })
    }
  )
);
x.displayName = t.ScrollDownButton.displayName;
const S = l(
  ({ className: e, ...o }, n) => /* @__PURE__ */ r(
    t.Label,
    {
      ref: n,
      className: i("px-2 py-1.5 text-sm font-medium text-gray-600", e),
      ...o
    }
  )
);
S.displayName = t.Label.displayName;
const h = l(
  ({ className: e, children: o, ...n }, a) => /* @__PURE__ */ r(
    t.Item,
    {
      ref: a,
      className: i(
        // base
        "flex cursor-pointer items-center gap-2 rounded-md p-2 text-sm font-medium leading-4 outline-none",
        // focus
        "focus:bg-gray-100",
        // disabled
        "radix-disabled:text-gray-500 radix-disabled:cursor-not-allowed",
        //
        e
      ),
      ...n,
      children: o
    }
  )
);
h.displayName = t.Item.displayName;
const y = l(
  ({ className: e, children: o, ...n }, a) => /* @__PURE__ */ r(
    t.Separator,
    {
      ref: a,
      className: i("-mx-1 my-1 h-px min-h-px bg-gray-100", e),
      ...n
    }
  )
);
y.displayName = t.Separator.displayName;
const z = T, E = I, G = p, P = j, M = u, k = S, A = h, F = B, O = y;
export {
  M as Content,
  E as Group,
  A as Item,
  F as ItemText,
  k as Label,
  z as Root,
  O as Separator,
  u as SingleSelectContent,
  g as SingleSelectContext,
  I as SingleSelectGroup,
  h as SingleSelectItem,
  B as SingleSelectItemText,
  S as SingleSelectLabel,
  T as SingleSelectRoot,
  y as SingleSelectSeparator,
  j as SingleSelectTrigger,
  P as Trigger,
  G as Value
};
